import styled from 'styled-components';
import { mediaQueries, size } from '@everlywell/leaves';

export const StripePaymentWrapper = styled.div.attrs(props => ({
  isInCart: props.isInCart,
}))`
  margin-top: ${props => props.isInCart ? '16px' : '0'};
  display: ${props => props.isInCart ? 'block' : 'inline'};

  margin-left: ${props => props.isInCart ? '0' : `${size.xs1}px`};
  width: 100%;

  ${mediaQueries.forTabletVerticalUp} {
    display: ${props => props.isInCart ? 'block' : 'none'};
  }
`;